var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScannerWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.014,
    height: 16.028,
    viewBox: "0 0 16.014 16.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_scanner",
    d: "M679.082-9196.959v-1.5h2.5v-2.5h1.5s-.032.59,0,3a1,1,0,0,1-1,1Zm-12.012-1.013v-3h1.5v2.5h2.5v1.5s-.59-.032-3,0A1,1,0,0,1,667.071-9197.972Zm3.526-2a.5.5,0,0,1-.5-.5v-2.078a.5.5,0,0,1,.029-.167h-1.4c-.585,0-1.061-.335-1.061-.749s.476-.749,1.061-.749h12.719c.585,0,1.061.335,1.061.749s-.476.749-1.061.749h-1.349a.5.5,0,0,1,.028.167v2.078a.5.5,0,0,1-.5.5Zm.5-2.58v1.579h8.028v-1.579a.5.5,0,0,1,.029-.167h-4.66v1.3h-2.8v-1.3h-.623A.5.5,0,0,1,671.1-9202.557Zm.994.737h2v-.9h-2Zm2.992.3v-.4h.8v-.4h1.2v.4h.257v-.4h.6v.4h-.4v.4h-.6v-.393h-.657v.4Zm2.858,0v-.4h.208v-.4h.314v.4h-.208v.4Zm1.184-4.271v-3.172H671.1v3.172a.5.5,0,0,1-.5.5.5.5,0,0,1-.5-.5v-3.674a.5.5,0,0,1,.5-.5h9.027a.5.5,0,0,1,.5.5v3.674a.5.5,0,0,1-.5.5A.5.5,0,0,1,679.124-9205.794Zm-7.434.215v-2.8h2.8v2.8Zm.4-.4h2v-2h-2Zm5,.2v-.4h-.4v-.8h-.8v-.4h-.4v.4h.4v.4h.4v.8h-.8v-.4h.4v-.4h-.4v-.4h-.4v-.8h.8v.4h.8v.4h.8v-.4h-.8v-.4h-.8v-.4h1.2v.4h.4v-.4h.4v.4h-.4v.4h.4v.4h.4v.8h-.8v-.4h-.4v.4h.4v.4Zm.4-.8h.4v-.4h-.4Zm-5,.2v-1.2h1.2v1.2Zm9.094-2.594v-2.5h-2.5v-1.5s.59.032,3,0a1,1,0,0,1,1,1v3Zm-14.5-.012s.035-.59,0-3a1,1,0,0,1,1-1h3v1.5h-2.5v2.5Z",
    transform: "translate(-667.071 9212.987)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScannerWidget);
export default __webpack_public_path__ + "static/media/ScannerWidget.2b677aa8.svg";
export { ForwardRef as ReactComponent };